import React, { useState } from "react";
import "../styles/gallery.scss";

import galleryImg1 from "../images/gallery/1.webp";
import galleryImg2 from "../images/gallery/2.webp";
import galleryImg3 from "../images/gallery/3.webp";
import galleryImg4 from "../images/gallery/4.webp";
import galleryImg5 from "../images/gallery/5.webp";
import galleryImg6 from "../images/gallery/6.webp";
import galleryImg7 from "../images/gallery/7.webp";
import galleryImg8 from "../images/gallery/8.webp";
import galleryImg9 from "../images/gallery/9.webp";
import galleryImg10 from "../images/gallery/10.webp";
import galleryImg11 from "../images/gallery/11.webp";
import galleryImg12 from "../images/gallery/12.webp";
import galleryImg13 from "../images/gallery/13.webp";
import galleryImg14 from "../images/gallery/14.webp";
import galleryImg15 from "../images/gallery/15.webp";
import galleryImg16 from "../images/gallery/16.webp";
import galleryImg17 from "../images/gallery/17.webp";
import galleryImg18 from "../images/gallery/18.webp";
import galleryImg19 from "../images/gallery/19.webp";
import galleryImg20 from "../images/gallery/20.webp";
import galleryImg21 from "../images/gallery/21.webp";
import galleryImg22 from "../images/gallery/22.webp";
import galleryImg23 from "../images/gallery/23.webp";

const images = [
  galleryImg1,
  galleryImg2,
  galleryImg3,
  galleryImg4,
  galleryImg5,
  galleryImg6,
  galleryImg7,
  galleryImg8,
  galleryImg9,
  galleryImg10,
  galleryImg11,
  galleryImg12,
  galleryImg13,
  galleryImg14,
  galleryImg15,
  galleryImg16,
  galleryImg17,
  galleryImg18,
  galleryImg19,
  galleryImg20,
  galleryImg21,
  galleryImg22,
  galleryImg23
];

const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openLightbox = index => {
    setCurrentImageIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const goToNextImage = () => {
    setCurrentImageIndex(
      prevIndex => (prevIndex === images.length - 1 ? 0 : prevIndex + 1)
    );
  };

  const goToPreviousImage = () => {
    setCurrentImageIndex(
      prevIndex => (prevIndex === 0 ? images.length - 1 : prevIndex - 1)
    );
  };

  return (
    <div className="gallery-container main-container">
      <h2 style={{ textAlign: "center" }} className="title">
        Galerija
      </h2>
      <div className="gallery-grid">
        {images.map((image, index) =>
          <div
            className="gallery-item"
            key={index}
            onClick={() => openLightbox(index)}
          >
            <img loading="lazy" src={image} alt={`Gallery item ${index + 1}`} />
            <div className="overlay">
              <span>Pogledajte sliku</span>
            </div>
          </div>
        )}
      </div>

      {isOpen &&
        <div className="lightbox-overlay">
          <div className="lightbox-content">
            <button className="close-button" onClick={closeLightbox}>
              &times;
            </button>
            <button className="prev-button" onClick={goToPreviousImage}>
              &#10094;
            </button>
            <img
              loading="lazy"
              src={images[currentImageIndex]}
              alt={`Gallery item ${currentImageIndex + 1}`}
            />
            <button className="next-button" onClick={goToNextImage}>
              &#10095;
            </button>
          </div>
        </div>}
    </div>
  );
};

export default Gallery;
